export const acceptedImageTypes = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
};
export const acceptedExcelTypes = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
export const acceptedFileTypes = {
  ...acceptedImageTypes,
  doc: 'application/msword',
  pdf: 'application/pdf',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: '.csv',
  txt: 'text/plain',
};

export const getFileExt = (file) => {
  const { name } = file;
  // eslint-disable-next-line no-bitwise
  return name.slice(((name.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();
};
